var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateReviewStar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9379 39.1198C25.3679 38.8199 24.6869 38.8196 24.1167 39.1189L13.5661 44.6573C12.1299 45.4112 10.4525 44.1914 10.7272 42.5927L12.7412 30.8704C12.8505 30.2342 12.6391 29.5851 12.1762 29.1352L3.63881 20.8379C2.47401 19.7058 3.11519 17.7295 4.72273 17.4969L16.5062 15.7918C17.1438 15.6995 17.6952 15.2994 17.9807 14.7219L23.2557 4.05006C23.9742 2.59664 26.0469 2.59664 26.7653 4.05006L32.0403 14.7219C32.3258 15.2994 32.8772 15.6995 33.5148 15.7918L45.2983 17.4969C46.9058 17.7295 47.547 19.7058 46.3822 20.8379L37.8448 29.1352C37.3819 29.5851 37.1706 30.2342 37.2799 30.8704L39.2931 42.5881C39.5679 44.1876 37.8888 45.4075 36.4525 44.6518L25.9379 39.1198Z",
    fill: "#354D9E",
    stroke: "#354D9E",
    strokeWidth: 0.734043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6957 24.6918C27.9998 24.6918 29.2526 25.9915 29.2526 27.9333C29.2526 29.7968 27.9529 31.2531 25.2751 31.2531C23.6934 31.2531 22.1901 30.7051 21.3445 29.8438L21.8926 28.9512C22.5973 29.6872 23.85 30.2196 25.2594 30.2196C27.1229 30.2196 28.1094 29.3113 28.1094 27.9803C28.1094 26.5709 27.2325 25.694 24.4451 25.694H22.1118L22.6756 20.1975H28.6732V21.1997H23.6621L23.2863 24.6918H24.6957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateReviewStar5);
export default __webpack_public_path__ + "static/media/IconRateReviewStar-5.2a43b94c11b9087bde7496dad0678c84.svg";
export { ForwardRef as ReactComponent };